<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Atualizar CPF do Paciente</h4>
            <div class="alert alert-info">
              <i class="bx bx-info-circle me-2"></i>
              Página em desenvolvimento
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Atualizar CPF do Paciente",
    meta: [{ name: "description", content: "Atualizar CPF do paciente" }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Atualizar CPF do Paciente",
      items: [
        { text: "Pacientes", href: "/patients" },
        { text: "Atualizar CPF", active: true },
      ],
    };
  },
};
</script>
